// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input {
   border-style: solid;
   border-width: 1px;
   border-color: rgba(0, 0, 0, 0.12);
   cursor: unset;
   padding: 5px 10px;
   margin: 4px 10px 10px 12px !important;
}

.txt-field-body {
   border-style: none;
}

.c-validation {
   font-weight: normal;
   font-size: 0.8125em;
   line-height: 1.3em;
   margin-top: -5px;
   margin-left: 12px;
   margin-right: 10px;
   color: red;
}

.validate-error {
   border-color: red;
}

input:focus {
   outline: none !important;
   border:1px solid rgba(0, 0, 0, 0.35);
}
`, "",{"version":3,"sources":["webpack://./src/app/e-form/form-generate/field-type/email/email.component.css"],"names":[],"mappings":"AAAA;GACG,mBAAmB;GACnB,iBAAiB;GACjB,iCAAiC;GACjC,aAAa;GACb,iBAAiB;GACjB,qCAAqC;AACxC;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,mBAAmB;GACnB,mBAAmB;GACnB,kBAAkB;GAClB,gBAAgB;GAChB,iBAAiB;GACjB,kBAAkB;GAClB,UAAU;AACb;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,wBAAwB;GACxB,oCAAoC;AACvC","sourcesContent":["input {\n   border-style: solid;\n   border-width: 1px;\n   border-color: rgba(0, 0, 0, 0.12);\n   cursor: unset;\n   padding: 5px 10px;\n   margin: 4px 10px 10px 12px !important;\n}\n\n.txt-field-body {\n   border-style: none;\n}\n\n.c-validation {\n   font-weight: normal;\n   font-size: 0.8125em;\n   line-height: 1.3em;\n   margin-top: -5px;\n   margin-left: 12px;\n   margin-right: 10px;\n   color: red;\n}\n\n.validate-error {\n   border-color: red;\n}\n\ninput:focus {\n   outline: none !important;\n   border:1px solid rgba(0, 0, 0, 0.35);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
